import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { MSAL_INSTANCE } from '@azure/msal-angular';
import { PublicClientApplication } from '@azure/msal-browser';

bootstrapApplication(AppComponent, appConfig).then(appRef => {
  const msalInstance = appRef.injector.get<PublicClientApplication>(MSAL_INSTANCE);
  msalInstance.initialize();
}).catch((err) => console.error(err));